import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import VSolonCard from "../Cards/VSolonCard";
import ScrollToTop from "../ScrollToTop";
import useCaseDetail from "../../features/cases/useCaseDetail";
import { useLayoutMode } from "../../layout/LayoutModeContext";

export const caseDocumentTitle = (singleCase) => {
  if (!singleCase) return "Δεν βρέθηκε η υπόθεση | MySolon.gr";
  let title = "";
  if (singleCase?.note !== undefined && singleCase?.note?.trim() !== "") {
    title = title + singleCase.note + " | ";
  }
  return (
    title +
    singleCase?.court +
    " | " +
    singleCase?.gak +
    "/" +
    singleCase?.year +
    " | MySolon.gr"
  );
};

const ViewCase = () => {
  const params = useParams();
  const { isDesktop } = useLayoutMode();
  const {
    data: singleCase,
    updates: singleUpdates,
    history: caseHistory,
    historyError,
    loading,
  } = useCaseDetail(params.caseId);

  useEffect(() => {
    if (loading) return;
    document.title = caseDocumentTitle(singleCase);
  }, [singleCase, loading]);

  const content = loading ? (
    <h2>Ανακτώνται τα δεδομένα... Παρακαλώ περιμένετε...</h2>
  ) : singleCase ? (
    <div>
      <ScrollToTop />
      <VSolonCard
        singleCase={singleCase}
        singleUpdates={singleUpdates}
        historyData={caseHistory}
        historyError={historyError}
        historyLoading={caseHistory === undefined}
      />
    </div>
  ) : (
    <h2>Δεν βρέθηκε η υπόθεση.</h2>
  );

  if (!isDesktop) return content;

  return (
    <div className="ds-fullpage-case">
      <nav className="ds-breadcrumb" aria-label="Πλοήγηση">
        <Link to={`/astika?case=${params.caseId}`}>← Αστικά</Link>
      </nav>
      {content}
    </div>
  );
};

export default ViewCase;
